module.exports = __webpack_public_path__ + "static/media/espand.22c6d818.svg";